export interface Title {
  id: string;
  name: string;
  function: TitleFunction;
  createdAt: string;
  updatedAt: string;
}

export enum TitleFunction {
  ENGINEERING = 'engineering',
  PRODUCT = 'product',
  DESIGN = 'design',
  CUSTOMER_SUCCESS = 'customer success',
  SALES = 'sales',
  MARKETING = 'marketing',
  HR = 'hr',
  FINANCE = 'finance',
  LEGAL = 'legal',
  TECH_OPS = 'tech ops',
}

export const TITLE_FUNCTION_LABELS: Record<TitleFunction, string> = {
  [TitleFunction.ENGINEERING]: 'Engineering',
  [TitleFunction.PRODUCT]: 'Product',
  [TitleFunction.DESIGN]: 'Design',
  [TitleFunction.CUSTOMER_SUCCESS]: 'Customer Success',
  [TitleFunction.SALES]: 'Sales',
  [TitleFunction.MARKETING]: 'Marketing',
  [TitleFunction.HR]: 'HR',
  [TitleFunction.FINANCE]: 'Finance',
  [TitleFunction.LEGAL]: 'Legal',
  [TitleFunction.TECH_OPS]: 'Tech Ops',
};

export function isValidTitleFunction(value: string): value is TitleFunction {
  return Object.values(TitleFunction).includes(value as TitleFunction);
}

export interface CreateTitleRequest {
  name: string;
  function: TitleFunction;
}

export interface UpdateTitleRequest {
  name?: string;
  function?: TitleFunction;
}

export const TITLE_VALIDATION = {
  MAX_NAME_LENGTH: 100,
} as const;
